import React from 'react';
import {withStyles} from "@material-ui/core";

import {SnackbarProvider, withSnackbar} from 'notistack';
import styles from "../styles";
import Login from "./Login";

import PropTypes from 'prop-types';
import {Grid, Hidden} from "@material-ui/core";
import LoaderOverlay from './LoaderOverlayMask'
class LoginWidget extends React.Component {
  render() {

    const LoginWithSnackbar = withSnackbar(Login);
    return (
      <SnackbarProvider maxSnack={1} anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}>
        <LoaderOverlay
          styles={{
            overlay: (base) => ({
              ...base,
              background: 'rgba(0, 0, 0, 0.1)'
            })
          }}
        >
          <Grid container>
            <Grid item xs={1}>
            </Grid>
            <Grid item xs={10} sm={4}>
              <LoginWithSnackbar
                header={this.props.header}
                defaultLocale={this.props.locale}></LoginWithSnackbar>
            </Grid>
            <Grid item xs={1}>
            </Grid>
            <Hidden smDown>
              <Grid item md={6} lg={6}>
                <img style={{float: "right", maxHeight: '100vh', maxWidth: "calc(100%)"}}
                     src={this.props.baseUrl + '/assets/woman_with_laptop.jpg'}/>
              </Grid>
            </Hidden>
          </Grid>
        </LoaderOverlay>
      </SnackbarProvider>
    )
  }
}

LoginWidget.propTypes = {
  header: PropTypes.string,
  locale: PropTypes.string,
  baseUrl: PropTypes.string
}
export default withStyles(styles)(LoginWidget);